import React from 'react'
import { Link } from 'react-router-dom'
import './Breadcrumb.css'

function Breadcrumb({ title, description, bgImage }) {
    return (
        <>
            <div className="breadcumb-wrapper animated-bg">
                <div className="breadcrumb-animation-overlay">
                    <div className="breadcrumb-icons">
                        <div className="breadcrumb-icon icon-home">
                            <i className="fas fa-home"></i>
                        </div>
                        <div className="breadcrumb-icon icon-info">
                            <i className="fas fa-info-circle"></i>
                        </div>
                        <div className="breadcrumb-icon icon-map">
                            <i className="fas fa-map-marked-alt"></i>
                        </div>
                        <div className="breadcrumb-icon icon-wifi">
                            <i className="fas fa-wifi"></i>
                        </div>
                        <div className="breadcrumb-icon icon-tower">
                            <i className="fas fa-broadcast-tower"></i>
                        </div>
                    </div>
                    <div className="breadcrumb-particles">
                        <div className="breadcrumb-particle particle-1"></div>
                        <div className="breadcrumb-particle particle-2"></div>
                        <div className="breadcrumb-particle particle-3"></div>
                        <div className="breadcrumb-particle particle-4"></div>
                    </div>
                </div>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{title}</h1>
                        <ul className="breadcumb-menu">
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>{title}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Breadcrumb
